import React from 'react'

const About = () => {
  return (
    <div name = "about" 
    className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'> 
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>About Sam Muthaiga</p>
            </div>
            <p className='text-xl mt-20'>
                 As a full stack developer with 2 and a half years of coding experience, I am a self-driven problem solver who is committed to delivering high-quality work. With a keen eye for detail and a passion for creating seamless user experiences, I pride myself on my ability to tackle complex challenges and come up with elegant solutions. Whether it's designing intuitive front-end interfaces or developing robust back-end systems, I am always eager to take on new projects and push the boundaries of what's possible in the world of software development.
            </p>
            <br/>

            <p className='text-xl'>
                In addition to my expertise in UI/UX design, frontend and backend development, I am also well-versed in project management tools and version control. With a focus on collaboration and efficient workflows, I ensure that every project is completed on time and to the highest standards.
            </p>
        </div>
    </div>
  )
}

export default About
